module.exports = "mat-form-field {\n    width: 250px;\n}"